import { render, staticRenderFns } from "./CrearRetencion.vue?vue&type=template&id=d4cac5aa&scoped=true"
import script from "./CrearRetencion.vue?vue&type=script&lang=js"
export * from "./CrearRetencion.vue?vue&type=script&lang=js"
import style0 from "./CrearRetencion.vue?vue&type=style&index=0&id=d4cac5aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cac5aa",
  null
  
)

export default component.exports